import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute,Params, Router } from '@angular/router';
import { MobileVehiclesService } from 'src/app/services/mobile/mobile-vehicles.service';
import { MobileReceiveVehicleFromPortService } from 'src/app/services/mobile/mobile-receive-vehicle-from-port.service';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-receive-vehicle-from-port',
  templateUrl: './receive-vehicle-from-port.component.html',
  styleUrls: ['./receive-vehicle-from-port.component.css']
})
export class ReceiveVehicleFromPortComponent implements OnInit{
  public vehicle_id: string = '';
  public isLoading: boolean = false;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  vehicle: any;
  spare_parts: any;
  searchText: string = '';
  selectedSpareParts: any[] = []; // Array to store selected spare parts
  selectedSparePartsIDs: any[] = []; // Array to store selected spare parts IDs
  @ViewChild('confirmSparePartsModal') modalElement!: ElementRef;
  form!: FormGroup;
  submitted: boolean = false;
  isChecked: boolean = false;
  needsRepair: boolean = false;
  locationId: any="";
  userId: any="";

  constructor(
      private mobileVehiclesService: MobileVehiclesService,
      private mobileReceiveVehicleFromPortService: MobileReceiveVehicleFromPortService,
      private activatedRoute:ActivatedRoute,
      private toastr: ToastrService,
      private router: Router,
      private location: Location,
      private formBuilder: FormBuilder
    ){
      this.form = this.formBuilder.group({
        comment:[''],
        needsRepair: [false],
      });
    }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((param: Params)=>{
      this.vehicle_id = param['get']('vehicle_id')
    })

    if(this.vehicle_id){
      this.isLoading=true;

      this.locationId=localStorage.getItem('locationId');
      this.userId=localStorage.getItem('userID');

      this.getVehicleData(this.vehicle_id);
    }else{
      this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
    }
  }

  /**
   * Get vehicle details
   * @param vehicle_id
   */
  getVehicleData(vehicle_id: string): void{
    this.mobileVehiclesService.getVehicle(vehicle_id)
    .subscribe({
      next: (response) => {
        if (response && Object.keys(response).length === 0) {
          this.isLoading=false;
          this.errorMessage="Unable to load vehicle details. Please refresh the page and try again!";
          this.toastr.error(this.errorMessage, 'Error!');
        }else{
          this.vehicle = response;
          if(this.vehicle.status==='no_data' || this.vehicle.status.length===0){
            this.isLoading=false;
            this.errorMessage="Unable to load vehicle details. Please refresh the page and try again.";
            this.toastr.error(this.errorMessage, 'Error!');
          }else{
            this.fetchSpareParts();
          }
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.toastr.error(error, 'Error!');
      }
    });
  }

  fetchSpareParts():void{
    this.mobileReceiveVehicleFromPortService.getVehicleSpareParts()
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.spare_parts = response.data;
          this.isLoading=false;
        }else if(response.status==='no_data'){
           this.errorMessage=response.message;
           this.isLoading=false;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isLoading=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isLoading=false;
      }
    });
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
  }

   // Function to handle checkbox change event
  checkboxChange(event: any, part: any) {

    if (event.target.checked) {

      this.selectedSpareParts.push({
        part_id: part.id,
        name: part.name
      });

    } else {

      const index = this.selectedSpareParts.findIndex(
        item => item.part_id === part.id
      );

      if (index !== -1) {
        this.selectedSpareParts.splice(index, 1);
      }
    }
  }

  openModal(){
    if (this.modalElement) {
      (<any>$(this.modalElement.nativeElement)).modal('show');
    }
  }

  closeModal():void {
    if (this.modalElement) {
      (<any>$(this.modalElement.nativeElement)).modal('hide');
    }
  }

  /**
   * Toggle vehicle needs repair checkbox
   */
  onCheckboxChange(): void {
    this.needsRepair = this.form.get('needsRepair')?.value;
  }

  confirmSpareParts(){
    if(this.selectedSpareParts.length===0){
      this.toastr.error("Please select available spare parts to proceed!", 'Error!');
    }else{
      this.openModal();

      //Clear previously selected spare parts IDs
      this.selectedSparePartsIDs.length = 0;

      this.selectedSpareParts.forEach(part => {
        this.selectedSparePartsIDs.push(
          part.part_id
        );
      });
    }
  }

  /**
   * Receive vehicle from port
   */
  receiveFromPort(){
    this.submitted = true;
    this.isLoading=true;

    if(this.selectedSparePartsIDs.length===0){

      let errorMessage="Please select spare parts to proceed!";
      this.toastr.error(errorMessage, 'Error!');

    }else{
      this.mobileReceiveVehicleFromPortService.receive(this.vehicle_id, this.vehicle.data.chassis_no ,this.selectedSparePartsIDs, this.needsRepair,this.form.value.comment,this.userId,this.locationId)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
           //Clear selected spare parts arrays
           this.selectedSpareParts.length = 0;
           this.selectedSparePartsIDs.length = 0;

           this.isLoading=false;  //Dismiss spinner
           this. closeModal(); //Close modal
           // Store chassis No.,log Id and transaction type in session for use
           // when uploading photos
           localStorage.setItem('chassisNo', this.vehicle.data.chassis_no);
           localStorage.setItem('logId', response.log_id);
           localStorage.setItem('txnType', 'receive');

           // Redirect to photos  screen
           this.toastr.success(response.message, 'Success!');
           this.router.navigate(['mobile/vehicle-transfer-photos']);
          }else if(response.status==='error'){
            this.errorMessage=response.message;
          }else{
            this.submitted = false;
            this.isLoading=false;
            this.toastr.error(response.message, 'Error!');
          }
        },
        error: (error) => {
          this.submitted = false;
          this.isLoading=false;
          this.toastr.error("An error occurred vehicle NOT received, please try again! ", 'Error!');
        }
      });
    }
  }

  goBack(): void {
    this.location.back();
  }
}
